<script lang="ts">
  import { _ } from 'svelte-i18n'
  import FilterModal from '../FilterModal.svelte';
  import ExerciseCard from '../ExerciseCard/ExerciseCard.svelte';
  import { getRequest, getDiamondFromDifficulty, parseStorage} from '../Util/utils';
  import route from '../Util/routes';

  // Selection stuff
  export let workout_id: string;
  export let viewport_height = 940;
  export let trial = false;

  let exercisesToShow = 4;

  function on_workout_selected(props) {
    let w = displayWorkouts.find(w=>w.path == props.path);
    if (w == null || w.path == workout_id) workout_id = undefined;
    else {
      // Only allow trial workouts for non-paid user.
      if (trial && !w.trial) return;
      workout_id = w.path;
    }
  }

  $: i_selected = displayWorkouts ? displayWorkouts.findIndex(w => w.path == workout_id) : undefined;

  // Workout loading related stuff
  export let workouts = [];
  export let displayWorkouts = [];
  export let date = null;

  // Modal/filter related stuff
  const filterKey = 'workoutFilter';
  let searchBox: string;
  let searchQuery: string = parseStorage(filterKey).searchBox ?? '';

  let minDuration: number;
  let maxDuration: number;
  let minXSS: number;
  let maxXSS: number;

  let selectedFocus;
  let selectedSpecificity;
  let minDiamonds;
  let maxDiamonds;

  let showStandard: boolean;
  let showCommunity: boolean;
  let showPersonal: boolean;

  let workoutsPromise;
  $: {
    const params = {'date': date != null ? date : ""};
    workoutsPromise = window.fetch(route('WorkoutController@getPlayableWorkouts')+'?'+(new URLSearchParams(params)).toString(), 
        {method: 'GET', ...getRequest()}).then((result)=>result.json()).then((result)=>{
      workouts = result.data;
      displayWorkouts = sortWorkouts();
    }).catch(error=>{
      console.log('Failed to fetch workouts in WorkoutPicker.svelte');
      console.error(error);
    });
  }

  // Functions
  function containsQuery(workout, query){
    if(workout.name.toLowerCase().includes(query.toLowerCase())) return true;
    if(workout.description.toLowerCase().includes(query.toLowerCase())) return true;
    if(workout.name.toLowerCase().includes(query.toLowerCase())) return true;
    if(workout.xss.toString().includes(query)) return true;

    return false;
  }

  function toMinutes(strTime) {
    if (typeof strTime == 'string') {
      console.log(strTime)
      if(strTime) return 60 * parseInt(strTime.substring(0, 2), 10) + parseInt(strTime.substring(3, 5), 10);
      else return 0;
    }
    return strTime / 60;
  }
  
  function sortWorkouts() {

    let sortedWorkouts = workouts;
    if(!sortedWorkouts) return [];

    // Select Workout Source
    let owners: {[type: string]: boolean; } = {
      'Admin': showStandard,
      'Coach': showCommunity,
      'User': showPersonal
    };

    sortedWorkouts = sortedWorkouts.filter(workout => owners[workout.owner]);

    // Filter by duration
    if(minDuration || maxDuration) sortedWorkouts = sortedWorkouts.filter(workout => (!minDuration || toMinutes(workout.duration) >= minDuration) && (!maxDuration || toMinutes(workout.duration) <= maxDuration));

    // Filter by XSS
    if(minXSS || maxXSS) sortedWorkouts = sortedWorkouts.filter(workout => (!minXSS || workout.xss >= minXSS) && (!maxXSS || workout.xss <= maxXSS));

    // Filter by focus
    let focuses = ['', 'Power Sprinter', 'Road Sprinter', 'Pursuiter', 'Puncheur', 'Breakaway Specialist', 'Rouleur', 'GC Specialist', 'Climber', 'Endurance'];
    if(selectedFocus.value != 0) sortedWorkouts = sortedWorkouts.filter(workout => workout.focus == focuses[selectedFocus.value]);

    // Filter by specificity
    let specificity = ['', 'Pure', 'Mixed', 'Polar']
    if (selectedSpecificity.value != 0) sortedWorkouts = sortedWorkouts.filter((workout) => workout.specRating == specificity[selectedSpecificity.value]);

    // Filter by difficulty
    if(minDiamonds || maxDiamonds) sortedWorkouts = sortedWorkouts.filter(workout => (!minDiamonds || getDiamondFromDifficulty(workout.difficulty) > (minDiamonds.value+2)/2) && (!maxDiamonds || getDiamondFromDifficulty(workout.difficulty) <= (maxDiamonds.value+2)/2));

    // Apply Search Query
    let queryArray = searchQuery.match(/("[^"]+")|([^ ]+)/g);
    //split the query by spaces, but ignore spaces if surrounded by quotes
    if(queryArray !== null && queryArray.length !== 0){
        queryArray.forEach((q) => {
            if(q.at(0) === '"'){
                //check to see if it starts with a quote, as the splitting process leaves surrounding quotes in
                q = q.replace(/"(.)*"/, q.substring(1, q.length-1));
            }
            sortedWorkouts = sortedWorkouts.filter(workout => containsQuery(workout, q));
        });
    }
    // Sort by recommended; most to least
    sortedWorkouts.sort((left, right) => {return left.advisorScore - right.advisorScore});

    return sortedWorkouts;

  };
</script>

<div id="workout-picker-container">
  <div class="title_container">
    <span class="caption-subject box_header text-center h3 bold" style="margin-bottom:20px">
      {$_('sessions.editor.workout')}
    </span>
    <FilterModal onApply={()=>{searchQuery = searchBox; displayWorkouts = sortWorkouts();}} showSource={true} title="Filter Workouts"
      bind:searchBox={searchBox} bind:minDuration={minDuration} bind:maxDuration={maxDuration} bind:minXSS={minXSS} bind:maxXSS={maxXSS} bind:minDiamonds={minDiamonds} bind:maxDiamonds={maxDiamonds}
      bind:showStandard={showStandard} bind:showCommunity={showCommunity} bind:showPersonal={showPersonal} bind:selectedSpecificity bind:selectedFocus showActivityFilters={false}/>
  </div>

  {#await workoutsPromise}
    Loading workouts... Please Wait...
  {:then}
    <div class="workouts-container" style="overflow: clip; flex-grow: 1;">
      <div style="max-height: {viewport_height}px; overflow-y: auto;">
        {#each displayWorkouts.slice(0, exercisesToShow) as exercise}
          <ExerciseCard selected_path={workout_id} exerciseType="Workout" {...exercise} showPlayButton={false} showScheduleButton={false} on:click={(_)=>{return on_workout_selected(exercise);}} selectable={true}/>
          <br/>
        {/each}
        
        {#if displayWorkouts.length > exercisesToShow}
          <div style="display: flex;">
            <spacer style="flex-grow: 1;"/>
            <button class="btn" on:click={()=>{exercisesToShow+=4;}}>Load More</button>
          </div>
        {/if}
      </div>
    </div>
  {/await}
</div>

<style lang="scss">
  #workout-picker-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .workouts-container {
    border: 1px solid #ECECEC;
    border-radius: 5px;
    padding: 2px;
  }

  button {
    background: var(--color-xert-teal);
    flex-shrink: 0;
    color: white;
    border-radius: 4px !important;
    height: 37px;
    margin: 10px auto;

    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

    &:hover {
      background: var(--color-xert-lime);
      color: white;
    }

    &:focus {
      color: white;
    }
  }
</style>